import request from '@/utils/request'

// 列表
export function listPage(data) {
  return request({
    url: 'admin/data/mhsupchems/list',
    method: 'post',
    data
  })
}

// 详情
export function info(id) {
  return request({
    url: 'admin/data/mhsupchems/info/' + id,
    method: 'get'
  })
}

// 新增
export function save(data) {
  return request({
    url: 'admin/data/mhsupchems/save',
    method: 'post',
    data
  })
}
// 修改
export function update(data) {
  return request({
    url: 'admin/data/mhsupchems/update',
    method: 'post',
    data
  })
}
// 初始化
export function init(data) {
  return request({
    url: 'admin/data/mhsupchems/init',
    method: 'post',
    data
  })
}

// 重大危险源
export function zdwxy(data) {
  return request({
    url: 'admin/mh/home/list',
    method: 'post',
    data
  })
}


// 删除
export function deleteData(data) {
  return request({
      url: 'admin/data/mhsupchems/delete',
      method: 'post',
      data
  })
}